export const NAME_KEY = "name";
export const TYPE_KEY = "type";
export const STATUS_KEY = "status";
export const PARENT_KEY = "parent";
export const EXTERNAL_ID_KEY = "ImportID";
export const ADDRESS_KEY = "geoLocationName";
export const RE_ADDRESS_STREET_KEY = "street";
export const RE_ADDRESS_POSTAL_CODE_KEY = "postalCode";
export const RE_ADDRESS_POSTAL_REGION_KEY = "postalRegion";
export const RE_ADDRESS_COUNTRY_KEY = "country";
export const RE_COORDINATES_KEY = "coordinates";
export const FRACTION_DISCRIMINATOR_KEY = "fractionDiscriminator";
export const FRACTION_KEY = "fraction";
export const FRACTION_DESC_KEY = "fractionDesc";
export const ACCESS_TOKEN_KEY = "accessToken";
export var UpdateMode;
(function (UpdateMode) {
    UpdateMode["MERGE"] = "MERGE";
    UpdateMode["SET"] = "SET";
})(UpdateMode || (UpdateMode = {}));
export var PointStatus;
(function (PointStatus) {
    PointStatus["ACTIVE"] = "ACTIVE";
    PointStatus["INACTIVE"] = "INACTIVE";
    PointStatus["PLANNED"] = "PLANNED";
    PointStatus["DEPRECATED"] = "DEPRECATED";
})(PointStatus || (PointStatus = {}));
export const POINT_STATUSES = [
    PointStatus.ACTIVE,
    PointStatus.INACTIVE,
    PointStatus.DEPRECATED,
    PointStatus.PLANNED,
];
//# sourceMappingURL=constants.js.map